module.exports = __webpack_public_path__ + "img/logo.085ae3f1.png";